import { makeSpacing } from './makeSpacing';
import { makeTypography } from './makeTypography';
import { defaultThemeDeclaration } from '../themes/defaultThemeDeclaration';
export var makeTheme = function makeTheme() {
  var theme = defaultThemeDeclaration;
  theme.spacing = makeSpacing(theme);
  theme.typography = makeTypography(theme.typography);
  theme.referenceIndex = {};
  return {
    armor: theme
  };
};